import { apiInstance } from 'common/utils/axios';

/** POST `/products/download` — el backend prepara y envía el Excel por correo */
export const downloadPartnerProducts = () => apiInstance.post('/products/partner-export', {});
